import Vue from 'vue'
import Router from 'vue-router'
import Select from '../views/cart/Select.vue'
import Balance from '../views/cart/Balance.vue'
import Bank from '../views/cart/Bank.vue'
import Pay from '../views/cart/Pay.vue'
import Success from '../views/cart/success.vue'
import Fail from '../views/cart/Fail.vue'

Vue.use(Router)

export default new Router({
    linkExactActiveClass: "active",
    routes: [{
            path: '/cart/select',
            name: 'select',
            component: Select,

        },
        {
            path: '/cart/pay',
            name: 'Pay',
            component: Pay,
            children: [{
                    path: '/cart/select/balance',
                    component: Balance
                },
                {
                    path: '/cart/select/bank',
                    component: Bank
                },
                // {
                //     path: '/cart/select/',
                //      redirect: '/cart/select/balance'
                //   }
            ],
            props: true
        },
        {
            path: '/cart/success',
            name: 'success',
            component: Success
        },
        {
            path: '/cart/fail',
            name: 'fail',
            component: Fail
        },
        {
            path: '/',
            redirect: "/cart/select"
        },
        {
            path: "*",
            redirect: "/cart/select"
        }

    ],
    mode: 'history'
})


// WEBPACK FOOTER //
// ./src/router/index.js